export var ObjectStore;
(function (ObjectStore) {
    var ShareAuthenticatorType;
    (function (ShareAuthenticatorType) {
        ShareAuthenticatorType["Email"] = "email_otp";
        ShareAuthenticatorType["Sms"] = "sms_otp";
        ShareAuthenticatorType["Password"] = "password";
    })(ShareAuthenticatorType = ObjectStore.ShareAuthenticatorType || (ObjectStore.ShareAuthenticatorType = {}));
    var ShareLinkType;
    (function (ShareLinkType) {
        ShareLinkType["Upload"] = "upload";
        ShareLinkType["Download"] = "download";
        ShareLinkType["Editor"] = "editor";
    })(ShareLinkType = ObjectStore.ShareLinkType || (ObjectStore.ShareLinkType = {}));
    /**
       * type APIListInput struct {
              Filter  json.RawMessage `json:"filter"`
              Last    []byte          `json:"last"`     // Last field for pagination.
              Limit   int             `json:"limit"`    // Maximum results to return in the first page.
              Order   string          `json:"order"`    // asc, desc
              OrderBy string          `json:"order_by"` // billable_size, created_at, md5_hex, owner, sha256_hex, size, type, updated_at
          }
  
          type APIListOutputObject struct {
              BillableSize int64             `json:"billable_size"`
              CreatedAt    time.Time         `json:"created_at"`
              ID           string            `json:"id"`
              MD5Hex       string            `json:"md5_hex"`
              Metadata     map[string]string `json:"metadata"`
              Name         string            `json:"name"`
              Owner        string            `json:"owner"`
              ParentID     string            `json:"parent_id,omitempty"`
              SHA256Hex    string            `json:"sha256_hex"`
              SHA512Hex    string            `json:"sha512_hex"`
              Size         int64             `json:"size"`
              Tags         []string          `json:"tags"`
              Type         string            `json:"type"`
              UpdatedAt    time.Time         `json:"updated_at"`
          }
      */
    var ObjectType;
    (function (ObjectType) {
        ObjectType["Folder"] = "folder";
        ObjectType["File"] = "file";
    })(ObjectType = ObjectStore.ObjectType || (ObjectStore.ObjectType = {}));
})(ObjectStore || (ObjectStore = {}));
